module.exports = __webpack_public_path__ + "img/add-circle.0a803833.svg";